import type { PaletteMode } from "@mui/material"

export const defaultSettings = {
  themeMode: "light" as PaletteMode,
  themeContrast: "bold",
  themeColorPresets: "satorange",
  themeStretch: false,
  themeLayout: "vertical",
}
